<template>
  <div class="app" :class="{[$route.name]: $route.name}">
    <div class="page-container" v-if="showPage">
      <router-view :key="$route.path + $route.query._t" />
    </div>
  </div>
</template>

<script>
import { hexToRgba, addStatistic, getQueryString } from './utils/tools.js';
import vconsole from 'vconsole';

export default {
  data() {
    return {
    }
  },
  computed: {
    formConfig() {
      return this.$store.state.formConfig;
    },
    showPage() {
      return getQueryString('preview') || this.formConfig?.id;
    }
  },
  watch: {
    '$route': {
      handler: function(val, oldVal){
        this.statisticPageView();
      }
    }
  },
  components: {
  },
  methods: {
    setTheme(color) {
      const style = document.createElement('style');
      style.type = 'text/css';
      const bgColor = hexToRgba(color, 5);
      const bgColor2 = hexToRgba(color, 20);
      style.innerHTML = `
      :root{
        --theme-main-color: ${color};
        --theme-bg-color: ${bgColor.rgba};
        --theme-bg-color-2: ${bgColor2.rgba};
      }
      `;
      document.getElementsByTagName('HEAD').item(0).appendChild(style);
    },
    statisticPageView() {
      if (this.formConfig.statistic_vendor === 'baidu') {
        window._hmt && window._hmt.push(['_trackPageview', this.$route.fullPath]);
        return false;
      }
      if (this.formConfig.statistic_vendor === 'google') {
        if (window.ga) {
          window.ga('create', this.formConfig.statistic_id, 'auto');
          window.ga('set', 'page', this.$route.fullPath);
          window.ga('send', 'pageview');
        }
        return false;
      }
    }
  },
  created() {
    
  },
  async mounted() {
    document.querySelector('.loadEffect')?.remove();
    if (getQueryString('isDebug')) {
      new vconsole();
      if(getQueryString('debug_token')) {
        window.localStorage.setItem('FORM_TOKEN', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2NTEwNDUzMTQsIm9pZCI6Im9zZHBLdF9qS0Z3UlVTSmJRemNkcXBVVlVYd2ciLCJuYW0iOiLpuqbmjK_ljYciLCJoaXUiOiJodHRwczovL3RoaXJkd3gucWxvZ28uY24vbW1vcGVuL3ZpXzMyL1EwajRUd0dUZlRJS0htQ212czU5Y1VMUXBPMTIzM3gwUndSaWIyZmoyTkI3QUJBVHhqaWJVaGNOVWJ4TXMxcXRKQWU3UU0yUzFMYnNqWjRGdGFSanZKencvMTMyIn0.7BkZJeqQbKY3V_5uNN0MbRTHRJy3sb3w2BJcW7781GQ');
      }
    }

    if (getQueryString('mode') === 'preview') {
      await this.$store.dispatch('getPreviewFormDetail', {
        id: getQueryString('form_id')
      });
    } else {
      await this.$store.dispatch('getFormConfig', {
        id: getQueryString('form_id')
      });
      if (this.$store.state.formConfig.statistic_vendor !== 'none' && this.$store.state.formConfig?.statistic_id) {
        addStatistic(this.$store.state.formConfig.statistic_vendor, this.$store.state.formConfig.statistic_id);
        setTimeout(() => {
          this.statisticPageView();
        }, 100);
      }
    }
    this.setTheme(this.$store.state.formConfig.theme_color);
    setTimeout(() => {
      if (window.wx) {
        this.$store.dispatch('wxJsInit', true);
      } else {
        // 预防jssdk尚未加载完，2秒后重试
        setTimeout(() => {
          this.$store.dispatch('wxJsInit', true);
        }, 2000);
      }
    }, 100);
  }
};
</script>

<style lang="less">
@import (reference) './assets/less/common.less';

body {
  
  #app {
  }
  .app {
    width: 100%;
    overflow: hidden;
    position: relative;
    z-index: 0;
    background-color: #fff;
    &.NoWeixin {
      background-color: #f0f5f1;
    }
  }
  .page-container {
    max-width: 10rem;
    overflow-y: auto;
    margin: 0 auto;
    position: relative;
  }
  
}
</style>
